import styled from '@emotion/styled/macro';
import {
  Button,
  SvgIcon,
  SvgNames,
  tokens,
} from '@sunrun/experience-ui-components';

const LearningSection = () => {
  return (
    <>
      <LearningTitle>RunX Learning</LearningTitle>
      <LearningDescription>
        Access your required and optional RunX learning courses.
      </LearningDescription>
      <LearningButton
        size="sm"
        color="secondary"
        onClick={() => window.open('https://sunrun.docebosaas.com/', '_blank')}>
        Go to RunX Learning{' '}
        <SvgIcon
          height={20}
          width={20}
          color={tokens.BRAND_HEROBLUE}
          name={SvgNames.ArrowSquareOutSvg}
        />
      </LearningButton>
    </>
  );
};

// Styled components
const LearningTitle = styled.h3`
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 600;
`;

const LearningDescription = styled.p`
  margin: 0 0 1rem 0;
  color: ${tokens.TINTS_OFF_WHITE_20};
  font-size: 0.875rem;
  flex: 1;
`;

const LearningButton = styled(Button)`
  margin-top: auto;
  width: 100%;
  > span {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export { LearningSection };
